import { useState, useEffect } from 'react';
import { accountService } from '../services/api';
import { BusinessUser, UpdateBusinessUserRequest } from '../types/auth';

export const useAccountSettings = () => {
  const [profile, setProfile] = useState<BusinessUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Carregar dados do perfil
  const loadProfile = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await accountService.getProfile();
      setProfile(data);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Erro ao carregar dados da conta');
      console.error('Erro ao carregar perfil:', err);
    } finally {
      setLoading(false);
    }
  };

  // Atualizar perfil
  const updateProfile = async (data: UpdateBusinessUserRequest): Promise<boolean> => {
    try {
      setSaving(true);
      setError(null);
      const updatedProfile = await accountService.updateProfile(data);
      setProfile(updatedProfile);
      return true;
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Erro ao atualizar dados da conta');
      console.error('Erro ao atualizar perfil:', err);
      return false;
    } finally {
      setSaving(false);
    }
  };

  // Carregar dados na inicialização
  useEffect(() => {
    loadProfile();
  }, []);

  return {
    profile,
    loading,
    saving,
    error,
    loadProfile,
    updateProfile,
  };
};
